import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import classnames from 'classnames'

import Button from './UI/Button'
import Input from "./UI/Input";

import {
  openUnsavedChangesModal,
  setCurrentPresetFromID,
  savePresetToStorage,
  saveNewPreset,
} from "../actions";

class UnsavedChanges extends Component {
  state = {
    newPresetName: false,
    isDuplicateName: false,
  };

  nameField = React.createRef();
  saveAsButton = React.createRef();

  componentDidMount() {}

  componentWillUnmount() {}

  handleCloseModal = () => {
    // close modal
    this.props.onCloseUnsavedChangesModal();
  };

  afterOpenModal = () => {
    ReactTooltip.rebuild();
    
    const nextPresetIsUser = this.props.presetID.includes("user");
    if (this.nameField.current && !nextPresetIsUser) this.nameField.current.focus();
  };

  handleButtonClick(type, id) {
    switch (type) {
      case "dontsave":
        // change preset
        this.props.onPresetChange(id);
        break;
      case "save":
        // save
        console.log("save current id", this.props.selectedPreset, 'future id', id);
        this.props.onSavePreset(
          this.props.currentPreset,
          this.props.selectedPreset
        );
        // change preset
        this.props.onPresetChange(id);
        break;
      case "saveas":
        // save as
        this.props.onSaveNewPreset(
          this.props.currentPreset,
          this.state.newPresetName
        );
        // change preset
        this.props.onPresetChange(id);
        break;
      case "cancel":
        // close
        break;

      default:
        break;
    }

    // close modal
    this.props.onCloseUnsavedChangesModal();
  }

  handleEnterPressed = (e) => {
    if(!!this.state.newPresetName && e.key === 'Enter') {
      this.saveAsButton.current.click();
    }
  }

  render() {
    const { 
      presetID, 
      user, 
      currentPreset, 
      selectedPreset,
      unsavedChangesOpen, 
    } = this.props;

    const currentPresetIsUser = selectedPreset.includes("user");

    return (
      <ReactModal
        isOpen={unsavedChangesOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.handleCloseModal}
        shouldCloseOnOverlayClick={false}
        className="react-modal unsaved-changes"
        overlayClassName="react-modal-overlay"
        contentLabel="Unsaved Changes"
      >
        <div className={classnames("unsaved-changes-panel")}>
          <p>Save Changes to [ {currentPreset.name} ]? </p>
          <div className={classnames("unsaved-changes-buttons")}>
            <Button
              name="Don't Save"
              onClick={() => this.handleButtonClick("dontsave", presetID)}
            />
            <Button
              name="Cancel"
              onClick={() => this.handleButtonClick("cancel")}
            />
            {currentPresetIsUser && (
              <Button
                name={`Save`}
                disabled={!currentPresetIsUser}
                onClick={() => this.handleButtonClick(`save`, presetID)}
              />
            )}
            {!currentPresetIsUser && (
              <Button
                name={`Save As`}
                ref={this.saveAsButton}
                disabled={
                  !this.state.newPresetName || this.state.isDuplicateName
                }
                onClick={() => this.handleButtonClick(`saveas`, presetID)}
              />
            )}
          </div>
          {!currentPresetIsUser && (
            <Input
              name="save-as-dialog"
              min="1"
              max="32"
              inputRef={this.nameField}
              placeholder={`${currentPreset.name} copy`}
              onKeyPress={this.handleEnterPressed}
              onInput={(e) => {
                const presetName = e.target.value;
                // check if preset name already exists and prevent saving if true
                this.setState({
                  newPresetName: presetName,
                  isDuplicateName: user.some(
                    (preset) => presetName === preset.name
                  ),
                });
              }}
            />
          )}
        </div>
      </ReactModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentPreset: state.currentPreset, // remove
    selectedPreset: state.editor.selectedPreset,
    unsavedChangesOpen: state.editor.unsavedChangesOpen,
    user: state.presets.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCloseUnsavedChangesModal: () => {
      dispatch(openUnsavedChangesModal(false));
    },
    onPresetChange: (id) => {
      dispatch(setCurrentPresetFromID(id));
    },
    onSaveNewPreset: (preset, name) => {
      dispatch(saveNewPreset(preset, name)); // save user preset to localStorage
    },
    onSavePreset: (preset, id) => {
      dispatch(savePresetToStorage(preset, id));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnsavedChanges);
